import { api } from '../serverClient';

// Active ranked season. Id, start/end window, reward preview, and the
// scoring constants. Returned shape:
//   { seasonId, startsAt, endsAt, minMatches, rewards: { coins: [..] },
//     scoring: { basePoints, minPoints, maxPoints } }
export async function getCurrentRankedSeason() {
  return api.get('/season-ranked/current');
}

// Paginated leaderboard for the current ranked season. Only players who
// have hit minMatches appear here. Pre-eligibility players are tracked
// but hidden. Returns { seasonId, rows, total, offset, limit }.
export async function getRankedSeasonLeaderboard({ offset = 0, limit = 50 } = {}) {
  const params = new URLSearchParams();
  params.set('offset', String(offset));
  params.set('limit', String(limit));
  try {
    const result = await api.get(`/season-ranked/leaderboard?${params}`);
    return {
      seasonId: result?.seasonId ?? null,
      rows: Array.isArray(result?.rows) ? result.rows : [],
      total: typeof result?.total === 'number' ? result.total : 0,
      offset,
      limit,
    };
  } catch (err) {
    console.error('[rankedSeasonApi] getRankedSeasonLeaderboard failed:', err);
    return { seasonId: null, rows: [], total: 0, offset, limit };
  }
}

// Caller's own seasonal score + rank. Returns
//   { seasonId, points, matchesPlayed, wins, losses, rank, total,
//     eligible, matchesUntilEligible }
// where `rank` is 1-based or null while the player is below minMatches.
export async function getRankedSeasonSelf() {
  try {
    return await api.get('/season-ranked/me');
  } catch (err) {
    console.error('[rankedSeasonApi] getRankedSeasonSelf failed:', err);
    return {
      seasonId: null,
      points: 0,
      matchesPlayed: 0,
      wins: 0,
      losses: 0,
      rank: null,
      total: 0,
      eligible: false,
      matchesUntilEligible: 10,
    };
  }
}

// Past season champions for the Hall of Fame view. Returns
//   { seasons: [{ seasonId, ranks: [{ rank, name, points, ... }] }] }
// newest seasons first, up to `limit` seasons.
export async function getRankedSeasonChampions({ limit = 30 } = {}) {
  try {
    const result = await api.get(`/season-ranked/champions?limit=${limit}`);
    return { seasons: Array.isArray(result?.seasons) ? result.seasons : [] };
  } catch (err) {
    console.error('[rankedSeasonApi] getRankedSeasonChampions failed:', err);
    return { seasons: [] };
  }
}
